var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"py-0",attrs:{"cols":"12"}},_vm._l((_vm.items),function(item,index){return _c('v-chip',{key:index,staticClass:"mr-2 mt-2"},[_vm._v(" "+_vm._s(item)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }